import { render } from "./LightbulbOn.vue?vue&type=template&id=c49700dc"
import script from "./LightbulbOn.vue?vue&type=script&lang=js"
export * from "./LightbulbOn.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/LightbulbOn.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c49700dc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c49700dc', __exports__)) {
    api.reload('c49700dc', __exports__)
  }
  
  module.hot.accept("./LightbulbOn.vue?vue&type=template&id=c49700dc", () => {
    api.rerender('c49700dc', render)
  })

}


export default __exports__